<template>
  <b-dropdown variant="none" :disabled="!watchingWarnings.length">
    <template #button-content>
      <span
        v-if="watchingWarnings.length"
        class="counter-alerts"
      >
        {{watchingWarnings.length}}
      </span>
    
      <bell-icon :style="`${watchingWarnings.length ? 'color: white' : ''}`"></bell-icon>
    </template>
    
    <div v-if="managementWarnings.length">
      <b-dropdown-header>
        Manejo
      </b-dropdown-header> 
      <div
        class="wrapper-warning px-4 py-3"
        v-for="(warning, i) in managementWarnings"
        :key="i"
      >
        • {{warning.text}}

      </div>
    </div>
  </b-dropdown>
</template>

<script>
import store from '@/store';
import { management } from '../../../api';
export default {
  data() {
    return {
      watchingWarnings: [],
    }
  },
  computed: {
    managementWarnings() {
      return this.watchingWarnings.filter(warn => warn.headerClass == 'management');
    },
  },
  async created() {
    if(this.$route.path !== "/login" && this.$route.path !== "/")  {
        try {
        const et0Status = await (management.et0UpdatedStatus());
        
        if(!et0Status.status) {
          this.watchingWarnings.push({
            isEt0Updated: et0Status.status,
            text: "Manejo desatualizado, preencha os valores de et0 dos dias que estão pendentes para obter sugestão de lâmina e agenda",
            headerClass: "management"
          });
        }

      } catch(e) {
        console.error(e);
      }
    }
    
  }
}
</script>
<style scoped>
.wrapper-warning {
  width: 100vw;
}

 @media (min-width: 992px) {
   .wrapper-warning {
     width: 33vw;
   }
  }

.counter-alerts {
  color: white;
  background-color: var(--orange-color);
  font-size: 0.9rem;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  z-index: 5;
  font-weight: bold;
  top: 0;
}
</style>